import moment from "moment";
import store from "../store";

const mixin = function () {
  return {
    computed: {
      user_doc() {
        return store.state.user_doc
      },
      manager_path(){
        return store.state.manager ? store.state.manager.path : null
      }
    },
    filters: {
      capitalize(sentence) {
        return sentence.replace(/\b\w/g, (l) => l.toUpperCase());
      },
      key_to_text(key) {
        return key.replace("_", " ");
      },
      format_date(timestamp) {
        return moment(timestamp).format("MM/DD/YYYY");
      },
      format_date_time(timestamp) {
        return moment(timestamp).format("MM/DD/YYYY hh:mm a");
      },
      format_time(timestamp) {
        return moment(timestamp).format("hh:mm a");
      },
      format_dow(timestamp) {
        return moment(timestamp).format("dddd");
      },
    },
    methods: {
      calcTimes() {
        let d = Date.now();
        return {
          createdAt: d,
          year: moment(d).format("Y"),
          month: moment(d).format("MMMM"),
          monthNum: moment(d).format("M"),
          day: moment(d).format("dddd"),
          dayNum: moment(d).format("d"),
        };
      },
      goTo(path) {
        this.$router.push({ path: path });
      },
      goToSurvyio(path) {
        window.location = `https://survyio.com/${path}`
      },
      showLogin(){
        this.$parent.$refs.header.showPopup = true;
      },
      mandrilKey() {
        return "";
      },
    },
  };
};

export default {
  mixin,
};
